if (window.location.pathname === '/cart') {
  // Label click → toggle nearest checkbox (avoids duplicate-ID issues across multiple snippet instances)
  document.addEventListener('click', (e) => {
    const label = e.target.closest('.autoship-option__label');
    if (!label) return;
    const checkbox = label.closest('.autoship-option')?.querySelector('.autoship-option__checkbox');
    if (!checkbox) return;
    checkbox.checked = !checkbox.checked;

    const content = checkbox.closest('.cart-upsell__content');
    if (!content) return;
    const subscribePrice = content.querySelector('.cart-upsell__product-price--subscribe');
    if (subscribePrice) subscribePrice.classList.toggle('hidden', !checkbox.checked);
  });

  // Add to cart
  document.addEventListener('click', async (e) => {
    if (!e.target.classList.contains('upsell-card-redesign')) return;

    const button = e.target;
    const container = button.closest('.js-upsell-container');
    const sellingPlanId = container?.dataset.sellingPlanId;
    const variantId = button.previousElementSibling.value;

    const contentArea = button.closest('.cart-upsell__desktop-content') || button.closest('.cart-upsell__mobile-content');
    const isChecked = contentArea?.querySelector('.autoship-option__checkbox')?.checked ?? false;

    const item = { id: variantId, quantity: 1 };
    if (isChecked && sellingPlanId) item.selling_plan = sellingPlanId;

    const originalText = button.textContent;
    button.disabled = true;
    button.innerHTML = '<span class="upsell-card-redesign__spinner"></span>';

    try {
      await fetch('/cart/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] }),
      });

      await cartRefresh();
    } finally {
      button.disabled = false;
      button.textContent = originalText;
    }
  });

  async function cartRefresh() {
    try {
      const res = await fetch(window.location.pathname);
      if (!res.ok) return;

      const html = document.createElement('div');
      html.innerHTML = await res.text();

      const hasItems = !!html.querySelector('.cart__item');
      document.querySelector('.wrap-cart')?.classList.toggle('hidden', !hasItems);
      document.querySelector('.empty-cart')?.classList.toggle('hidden', hasItems);
      if (!hasItems) return;

      ['.js-cart-items', '.js-cart-items-mobile', '.cart_count'].forEach((sel) => {
        const updated = html.querySelector(sel);
        if (updated) document.querySelector(sel).innerHTML = updated.innerHTML;
      });

      document.querySelectorAll('.dtc-free-shipping-progress').forEach((el) => {
        const updated = html.querySelector('.dtc-free-shipping-progress');
        if (updated) el.innerHTML = updated.innerHTML;
      });

      document.querySelectorAll('.subtotal-content__container .js-cart_subtotal').forEach((el) => {
        const updated = html.querySelector('.subtotal-content__container .js-cart_subtotal');
        if (updated) el.innerHTML = updated.innerHTML;
      });

      document.querySelectorAll('.subtotals-cart').forEach((el) => {
        const updated = html.querySelector('.cart_subtotal');
        if (updated) el.innerHTML = updated.innerHTML;
      });

      document.querySelectorAll('.subtotal-container .js-upsell-container').forEach((el) => {
        const updated = html.querySelector('.subtotal-container .js-upsell-container');
        if (updated) el.innerHTML = updated.innerHTML;
      });

      document.dispatchEvent(new Event('cart:reloaded'));
    } catch (err) {
      console.error('Cart upsell refresh failed:', err);
    }
  }
}
